import React, { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { LuPlus } from "react-icons/lu";
import "../DeshBoard.css";
import { Api } from "../../../services/httpService";
import Loader from "../Loader";
import LoaderModal from "../LoaderModal";
import { HiOutlinePencil } from "react-icons/hi2";
import { set } from "lodash";
import { IoCheckmarkCircle } from "react-icons/io5";
const CompanyList = ({
  triggerProgressRefresh,
  setCompanyData,
  setCompanyName,
  loading,
  setLoading,
  companies,
  fetchCompanies,
  showOverView,
  setCompanyId,
  setValueAuditReport,
  setValueSalesForecast,
  setValueVatReturns,
  setSectionStatus,
}) => {
  const merchantId = localStorage.getItem("_id");
  const [companyListForStatus, setCompanyListForStatus] = useState([]);

  const fetchCompanyStatus = async () => {
    // setLoading(true);
    try {
      const response = await Api(
        "get",
        `/company/getCompanyListWithStatusBySection/${merchantId}?sectionType=FINANCIAL`
      );

      if (response && response.body) {
        setCompanyListForStatus(response.body.companies);
        triggerProgressRefresh();
      }
      //  setLoading(false);
    } catch (error) {
      // setLoading(false);
    }
  };
  useEffect(() => {
    fetchCompanyStatus();
  }, [merchantId]);
  const getCompanyStatusNode = (company) => {
    const com = companyListForStatus?.find(
      (item) => item?.companyId === company?.id
    );

    if (com?.sectionStatus === "SUBMITTED") {
      return (
        <div className="note-btn comp-btn w-100">
          {" "}
          <span>
            <IoCheckmarkCircle />
            Submitted {" "}
          </span>
          {" "}
        </div>
      );
    } else if (com?.sectionStatus === "IN_PROGRESS") {
      return (
        <div className="note-btn w-100">
          <span className="text-primary">In Progress</span>
          {" "}
        </div>
      );
    } else if (com?.sectionStatus === "NOT_STARTED") {
      return (
        <div className="note-btn w-100">
          <span>Not Started</span>
          {" "}
        </div>
      );
    } else if (com?.sectionStatus === "UNDER_REVIEW") {
      return (
        <div className="note-btn w-100">
         <span>Under Review</span>
          {" "}
        </div>
      );
    } else if (com?.sectionStatus === "APPROVED") {
      return (
        <div className="note-btn w-100">
          <span className="text-success">Approved</span>
          {" "}
        </div>
      );
    } else if (com?.sectionStatus === "REJECTED") {
      return (
        <div className="note-btn w-100">
          {" "}
          <span style={{ fontSize: "16px", color: "#B22D2D" }}>Rejected</span>
          {" "}
        </div>
      );
    } else if (com?.sectionStatus === "NEEDS_ATTENTION") {
      return (
        <div className="note-btn w-100 ">
          <span style={{ fontSize: "16px" }}>Needs Attention</span>
          {" "}
        </div>
      );
    } else {
      return (
        <div className="note-btn w-100">
          <span>Not Started</span>
          {" "}
        </div>
      );
    }
  };

  const getButtonStatus = (company) => {
    const com = companyListForStatus?.find(
      (item) => item?.companyId === company?.id
    );
    console.log("company status", com);
    if (com?.sectionStatus === null) {
      return (
        <Button
          className="d-flex align-items-center"
          variant="primary"
          onClick={() => {
            showOverView(true, company);
            setCompanyId(company.id);
            setValueAuditReport(
              company?.isNotApplicableAuditedFinancialReport ? 1 : 0
            );
            setValueSalesForecast(
              company?.isNotApplicableSalesForecast ? 1 : 0
            );
            setValueVatReturns(company?.isNotApplicableVatReturns ? 1 : 0);
            setCompanyName(company.tradeName);
            setCompanyData(company);
            setSectionStatus(com?.sectionStatus);
          }}
        >
          Start
          <span>
            <LuPlus />
          </span>
        </Button>
      );
    } else {
      return (
        <Button
          className="d-flex align-items-center"
          variant="primary"
          onClick={() => {
            showOverView(true, company);
            setCompanyId(company.id);
            setValueAuditReport(
              company?.isNotApplicableAuditedFinancialReport ? 1 : 0
            );
            setValueSalesForecast(
              company?.isNotApplicableSalesForecast ? 1 : 0
            );
            setValueVatReturns(company?.isNotApplicableVatReturns ? 1 : 0);
            setCompanyName(company.tradeName);
            setCompanyData(company);
            setSectionStatus(com?.sectionStatus);
          }}
        >
          Edit
          <HiOutlinePencil />
        </Button>
      );
    }
  };
  return (
    <div className="company-info-box">
      <div className="container">
        <div className="row">
          {loading ? (
            <div className="col-12 text-center">
              <Loader />
            </div>
          ) : companies?.length > 0 ? (
            companies.map((company, index) => (
              <div className="col-12" key={index}>
                <div className="company-info-inner d-flex align-items-start flex-wrap p-3 mb-3">
                  <p className="info-title m-0">{company.tradeName}</p>
                  <div className="info-start ms-auto">
                    {getButtonStatus(company)}
                  </div>
                  {getCompanyStatusNode(company)}
                </div>
              </div>
            ))
          ) : (
            <div className="col-12">
              <div className="company-info-inner d-flex align-items-start flex-wrap p-3 mb-3">
                <p className="info-title m-0">
                  No companies found. Please add a company.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanyList;
